import React from "react";
import "./Contact.scss";
import {contactInfo, socialMediaLinks} from "../../portfolio";
import {Fade} from "react-reveal";

const footerSocials = [
  {
    href: socialMediaLinks.facebook,
    icon: "fab fa-facebook-f",
    label: "Facebook"
  },
  {
    href: socialMediaLinks.instagram,
    icon: "fab fa-instagram",
    label: "Instagram"
  },
  {
    href: socialMediaLinks.twitter,
    icon: "fab fa-twitter",
    label: "Twitter"
  },
  {
    href: socialMediaLinks.linkedin,
    icon: "fab fa-linkedin-in",
    label: "LinkedIn"
  },
  {
    href: socialMediaLinks.github,
    icon: "fab fa-github",
    label: "GitHub"
  },
  {
    href: socialMediaLinks.gmail
      ? `mailto:${socialMediaLinks.gmail}`
      : `mailto:${contactInfo.email_address}`,
    icon: "fas fa-envelope",
    label: "Email"
  }
].filter(item => item.href);

export default function Contact() {
  return (
    <Fade bottom duration={1000} distance="20px">
      <section className="contact-footer-section" id="contact">
        <div className="contact-cta-band">
          <a
            className="contact-hit-button"
            href="https://wa.me/263713630190"
            target="_blank"
            rel="noopener noreferrer"
          >
            <span aria-hidden="true"></span>
            Hit me up...
          </a>
          <div className="contact-cta-panel">
            <a
              className="contact-blue-button"
              href="https://wa.me/263713630190"
              target="_blank"
              rel="noopener noreferrer"
            >
              Get in touch
            </a>
          </div>
        </div>

        <div className="contact-network">
          <div className="contact-network-layer" aria-hidden="true"></div>
          <div className="contact-vertical-brand" aria-hidden="true">
            <span>Mbongeni</span>
            <span>Nsingo</span>
          </div>

          <div className="contact-footer-grid">
            <div className="contact-footer-column contact-twitts">
              <h2>01. Network</h2>
              <div className="contact-dotted-line"></div>
              <a
                className="contact-follow-button"
                href={socialMediaLinks.linkedin}
                target="_blank"
                rel="noopener noreferrer"
              >
                Follow on LinkedIn
              </a>
            </div>

            <div className="contact-footer-column contact-details-column">
              <h2>02. Contacts</h2>
              <div className="contact-dotted-line"></div>
              <div className="contact-detail-list">
              {contactInfo.number && (
                <a
                  className="contact-footer-detail"
                  href={"tel:" + contactInfo.number}
                >
                    <i className="fas fa-phone-alt"></i>
                    <span>Phone :</span>
                    <strong>{contactInfo.number}</strong>
                </a>
              )}
              <a
                  className="contact-footer-detail"
                href={"mailto:" + contactInfo.email_address}
              >
                  <i className="far fa-envelope"></i>
                  <span>Email :</span>
                  <strong>{contactInfo.email_address}</strong>
              </a>
                <p className="contact-footer-detail">
                  <i className="fas fa-map-marker-alt"></i>
                  <span>Address</span>
                  <strong>Zimbabwe</strong>
                </p>
              </div>

              <div className="contact-footer-socials">
                {footerSocials.slice(0, 4).map(item => (
                  <a
                    key={item.label}
                    href={item.href}
                    aria-label={item.label}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <i className={item.icon}></i>
                  </a>
                ))}
              </div>
            </div>
          </div>

          <p className="contact-copy">
            &copy; Mbongeni Nsingo 2024 / All Rights Reserved.
          </p>
        </div>
      </section>
    </Fade>
  );
}
